import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { BasicInfoApiService } from '@core/http/api/basic-info.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DEMO_PASSWORD, DEMO_USERNAME } from '@core/demo/demo-credentials';

@Component({
  selector: 'app-demo-login-modal',
  imports: [
    ReactiveFormsModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzModalModule,
  ],
  templateUrl: './demo-login-modal.component.html',
  styleUrl: './demo-login-modal.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoLoginModalComponent {
  private fb = inject(FormBuilder);
  private basicInfoApi = inject(BasicInfoApiService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  readonly visible = input.required<boolean>();
  readonly loginSuccess = output<void>();
  readonly modalBodyStyle = {
    maxHeight: 'calc(100vh - 64px)',
    overflowY: 'auto',
    padding: '24px 32px',
  };

  readonly loginForm = this.fb.nonNullable.group({
    username: [DEMO_USERNAME, Validators.required],
    password: [DEMO_PASSWORD, Validators.required],
  });

  isSubmitting = false;
  errorMessage = '';

  submit(): void {
    if (this.loginForm.invalid) {
      Object.values(this.loginForm.controls).forEach((control) => {
        control.markAsDirty();
        control.updateValueAndValidity();
      });
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    this.basicInfoApi.demoLogin({ params: this.loginForm.getRawValue() }).subscribe({
      next: (response: ApiResponse) => {
        if (response?.info?.ok) {
          this.loginSuccess.emit();
          return;
        }

        this.isSubmitting = false;
        this.errorMessage = response?.info?.message || '账号或密码错误';
        this.changeDetectorRef.markForCheck();
      },
      error: () => {
        this.isSubmitting = false;
        this.errorMessage = '登录失败，请稍后重试';
        this.changeDetectorRef.markForCheck();
      },
    });
  }
}
